import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { TOOLS } from "@/lib/tools";

export default function NotFoundPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 text-center">
      <Seo title="Seite nicht gefunden | Rechnerkiste" description="Diese Seite gibt es nicht. Hier sind alle Rechner der Rechnerkiste." />
      <meta name="robots" content="noindex" />
      <h1 className="text-3xl font-semibold tracking-tight">Seite nicht gefunden</h1>
      <p className="mt-3 text-muted-foreground">
        Diese Seite gibt es nicht oder wurde verschoben. Wähle einen Rechner oder geh zur{" "}
        <Link to="/" className="text-primary hover:underline">Startseite</Link>.
      </p>
      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-2 text-left">
        {TOOLS.map((t) => (
          <a key={t.id} href={t.url} className="rounded-lg border px-3 py-2 text-sm text-muted-foreground hover:text-foreground hover:border-primary/50">
            {t.name}
          </a>
        ))}
      </div>
    </div>
  );
}
